import { inject } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { CanActivateFn } from '@angular/router';
import { ConfigService } from '@rxap/config';
import { IngestingComponent } from '../components/ingesting/ingesting.component';
import {
  legacyRequestApiServerFeatures,
  RequestApiFeatureService,
} from '../request-api/request-api-features.service';
import { RequestApiIngestService } from '../request-api/request-api-ingest.service';
import { iirdsStore } from '../stores/iirds.store';

export const ingestGuard: CanActivateFn = async () => {
  const ingestService = inject(RequestApiIngestService);
  const featureService = inject(RequestApiFeatureService);
  const config = inject(ConfigService);
  const dialog = inject(MatDialog);
  const iirds = inject(iirdsStore);

  if (!config.get('api.iirds.enabled')) {
    return true;
  }

  // spec-compliant servers only get the ingest workflow when they advertise
  // it; an unreachable features endpoint falls back to the legacy behavior
  const features = await featureService
    .getFeatures()
    .catch(() => legacyRequestApiServerFeatures());

  // held in an object so the reassignment inside the onWaiting closure below
  // doesn't confuse TS's control flow narrowing of a plain `let` into `never`
  const dialogRef: { current: MatDialogRef<any> | null } = { current: null };
  try {
    if (features.ingest) {
      // route guard: poll indefinitely, surfacing the ingesting dialog
      await ingestService.ensureIngested(() => {
        dialogRef.current ??= dialog.open(IngestingComponent);
      }, Infinity);
    }
    await iirds.fetchData();
  } finally {
    dialogRef.current?.close();
  }
  return true;
};
